// extracted by mini-css-extract-plugin
module.exports = {"link":"MediaLinkDarkTheme_link__3JkXV","icon":"MediaLinkDarkTheme_icon__2r5le"};